import React from 'react'
import {
  CssBaseline,
  Stack,
} from "@mui/material";
import { Orderbody } from './Orderbody';
import Navbar from "../../redesign/components/Navbar";
import Footer from "../../redesign/components/Footer";
const Myorderpage = () => {
  return (
    <div>
            <CssBaseline />
        <Navbar />
        <Orderbody />
        <Footer />
    </div>
  )
}

export default Myorderpage